export const Apptype = "application/json";
export const SystemError = "System Error";
export const BusinessError = "Business Error";
export const NoDataFound = "No data found !!!";
export const ErrorInFetchingData = "Error in fetching data";
export const NotApplicable = "Not applicable";
export const Spec200V1 = "Spec 200 V1";
export const Spec200V2 = "Spec 200 V2";
export const AccessoryCode = "Accessory Code";
// Axios Errors
export const AxiosErrorConst = "Axios error:";
export const ErrorData = "Error Data:";
export const GeneralErrorConst = "General error:";
